export default "__VITE_ASSET__B63Jv8IH__"